import React from "react";
import { Link } from "react-router-dom";

interface LinkItem {
    text: string;
    to: string;
}

interface FooterColumnProps {
    title: string;
    links: LinkItem[];
}

const FooterColumn: React.FC<FooterColumnProps> = ({ title, links }) => {
    return (
        <section className="flex flex-col">
            <h2 className="mb-6 text-2xl font-bold">{title}</h2>
            <nav className="flex flex-col gap-2">
                {links.map((link, index) => (
                    <Link
                        key={index}
                        to={link.to}
                        className="text-sm cursor-pointer hover:underline"
                    >
                        {link.text}
                    </Link>
                ))}
            </nav>
        </section>
    );
};

export default FooterColumn;
